import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { requireSettingsSection } from '../../lib/router/route-guards';

const ServiceRequestReasonsPage = lazy(() =>
  import('../../pages/settings/service-request-reasons/ServiceRequestReasonsPage').then((m) => ({
    default: m.ServiceRequestReasonsPage,
  })),
);

export const Route = createFileRoute('/settings/service-request-reasons')({
  beforeLoad: ({ context }) => requireSettingsSection(context.queryClient, 'service-request-reasons'),
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <ServiceRequestReasonsPage />
    </Suspense>
  ),
});
